import {Modal} from "../../../../components/modal/modal.jsx";
import Button from "../../../../components/button/button.jsx";
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import React, {useState} from "react";
import {addHours, differenceInDays, isAfter} from "date-fns";
import InputForm from "../../../../components/input/input-form.jsx";
import projectUtils from "../../../../utils/project-utils.js";
import {isValidDate} from "@fullcalendar/core/internal";
import Loader from "../../../../components/template/loader.jsx";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const MySwal = withReactContent(Swal);
const GeoreferencedSearchCortexModal = ({open, setOpen, setData, user, setIsLoading}) => {
    const [dtStart, setDtStart] = useState(new Date());
    const [dtEnd, setDtEnd] = useState(addHours(new Date(), 1));
    const [plate, setPlate] = useState("");

    const apply = () => {
        const hasError = cortexFiltersValidation(dtStart, dtEnd, plate);

        if(hasError){
            projectUtils.swalErrorMessage("", hasError, "Ok");
            return
        }

        const filter = {
            dtIni: dtStart, dtEnd, plate
        }
        setIsLoading(true);
        axios.post(`${API_KEEPER}/cortex/passagesByFilter`, filter, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
                const data = response.data;

                if(data.length === 0) {
                    projectUtils.swalMessage("warning", "","Nenhum registro encontrado", "Ok")
                }

                setData(prev => {
                    const existingIds = new Set(prev.map(item => item.cortexId));

                    const newItems = data
                        .filter(el => !existingIds.has(el.idMovimento))
                        .map(el => ({
                            id: `cortex_${el.idMovimento}`,
                            plate: {rawValue: plate, formattedValue: plate},
                            isFromCortex: true,
                            cortexId: el.idMovimento,
                            dtCapture: el.dataPassagem,
                            dtCaptureYmd: el.dataPassagem,
                            latitude: el.latitude,
                            longitude: el.longitude,
                            routeName: el.local
                        }));


                    return [...prev, ...newItems]
                })
                setOpen(false);
        }).catch((error) => {
                let message = 'Ocorreu um erro na requisição de dados do indivíduo.';
                if (error.response.status !== 500) {
                    switch (error.response.data.message) {
                        case "plate.isnull": message = "Campo 'Placa' não pode ser vazio."; break;
                        case "dtIni.isnull": message = "Campo 'Data Inicial' não pode ser vazio."; break;
                        case "dtEnd.isnull": message = "Campo 'Data Final' não pode ser vazio."; break;
                        case "cortex.not.enabled": message = "Cortex desativado."; break;
                        case "cortex.cpf.invalid": message = "O usuário atual não possui CPF cadastrado."; break;
                        case "cortex.token.expired": message = "Chave do cortex expirada."; break;
                        case "cortex.token.invalid": message = "Chave do cortex inválida."; break;
                        case "cortex.not.allow.renavam": message = "Usuário sem permissão de acesso ao  CÓRTEX - RENAVAM."; break;
                        case "cortex.not.allow.passages": message = "Usuário sem permissão de acesso ao CÓRTEX - PASSAGENS."; break;
                        case "cortex.not.allow.individual": message = "Usuário sem permissão de acesso ao CÓRTEX - INDIVÍDUOS."; break;
                        default: message = 'Ocorreu um erro na requisição de dados do indivíduo.';
                    }
                }

                message !== "O usuário atual não possui CPF cadastrado."
                  ? projectUtils.swalErrorMessage('', message, 'Ok')
                  : MySwal.fire({icon: 'warning', confirmButtonColor: '#063A6C', html: `<span style="color:#b91c1c">${message}</span>`})

        }).finally(() => setIsLoading(false))

    }

    function cortexFiltersValidation(dtStart, dtEnd, plate) {
        if (!dtStart) return `O campo "Data inicial" é obrigatório.`;
        if (!dtEnd) return `O campo "Data final" é obrigatório.`;
        if (!plate) return `O campo "Placa" é obrigatório.`;

        const plateIsValid = isValidPlate(plate);

        if (!isValidDate(dtStart)) {
            return "Insira uma data inicial válida.";
        }

        if (!isValidDate(dtEnd)) {
            return "Insira uma data final válida.";
        }

        if (isAfter(dtStart, dtEnd)) {
            return "A data final precisa ser maior que a data inicial.";
        }

        const diffDays = differenceInDays(dtEnd, dtStart);

        if (diffDays > 90) {
            return "As pesquisas no Córtex estão limitadas a um período máximo de 90 dias.";
        }

        if (!plateIsValid) {
            return "A placa não é válida.";
        }

        return "";
    }

    function isValidPlate(plate) {
        const plateRegex = /^[A-Z]{3}-?\d{1}[A-Z\d]{1}\d{2}$/i;
        return plate.match(plateRegex)
    }

    return(
        <>
            <Modal title="Passagens do Córtex" open={open} setOpen={setOpen} className="w-4/12">

                <Modal.Body>
                    <div className="flex gap-2 mt-2">
                        <InputDateTime
                            classNameWrapper="flex-1"
                            id="dtStart"
                            selected={dtStart ? dtStart : undefined}
                            onChange={(date) => setDtStart(date)}
                            label={"Data inicial *"}
                            dateFormat="LL"
                        />
                        <InputDateTime
                            classNameWrapper="flex-1"
                            id="dtEnd"
                            selected={dtEnd ? dtEnd : undefined}
                            onChange={(date) => setDtEnd(date)}
                            label={"Data final *"}
                            dateFormat="LL"
                        />
                        <InputForm id="cortex-plate" classNameWrapper="flex-1" inputClass="font-bold" label="Placa *" value={plate} onChange={({target}) => setPlate(target.value.toUpperCase())}/>
                    </div>
                    <div className="w-full border-b border-b-[#d9dada] my-6"></div>
                    <div className="flex justify-center">
                    <span className="text-center text-[16px] italic">
                        * Por exigência do Ministério da Justiça, as consultas <br/>
                        efetuadas durante essa sessão serão vinculadas ao CPF do <br/>
                        usuário ativo: <span className="font-bold">{user.cpf}</span>
                    </span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="flex gap-2 w-full justify-end">
                        <Button onClick={apply}>Confirmar</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default GeoreferencedSearchCortexModal;